import { FC, useState } from "react"
import { address } from "../../pages/Perfil/addresses/addressesIndex"

import './index.css'
import { DotsIcon } from "../MenuIcons/Dots"
import { cepToMask } from "../../functions/mask"
import { useNavigate } from "react-router"
import useAuth from "../../hooks/useAuth"

type props = {
    data: address
    deleteAddress: (id:number) => void
}


const AddressCard: FC<props> = ({ data, deleteAddress }) => {

    const [open, setOpen] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)

    const navigate = useNavigate()
    const { loginInfo } = useAuth()

    const [boxPosition, setBoxPosition] = useState({ top: 0, left: 0 });;
    function FloatBox(e: any) {
        try {
            const rect = e.currentTarget.getBoundingClientRect();
            setBoxPosition({ top: rect.bottom + 7, left: rect.left - 75 });
            setOpen(!open)
        } catch (error) {
            console.log(error)
        }

    }

    function edit() {
        navigate(`${data.id}`)
    }


    return (
        <>
            <div className="addressMainContent" >
                <div className="addressContent" onClick={() => setOpen(false)}>
                    <span>{data.district},{data.street},{data.number}</span>

                    {data.complement &&
                        <span>{data.complement}</span>
                    }
                    <span>{data.city},{data.state},{cepToMask(data.zipCode)}</span>

                </div>

                <div className="buttonOption">

                    <button onClick={(event) => FloatBox(event)}><DotsIcon /></button>


                </div>

            </div>
            {
                open && (
                    <div className="floatingMenu" style={{ position: "fixed", top: `${boxPosition.top}px`, left: `${boxPosition.left}px` }}>
                        <div className="floatingMenucontent">
                            <button onClick={() => edit()}><span>Editar</span></button>
                            <button onClick={() => setDeleteModal(!deleteModal)}><span>Excluir</span></button>
                        </div>

                    </div>
                )

            }

            {deleteModal && (
                <div className="deleteModal">
                    <div className="deleteModalContent">
                        <div className="headerModal" >
                            <h5>Excluir endereço</h5>

                            <button onClick={() => setDeleteModal(false)} ><span>x</span></button>
                        </div>

                        <div className="bodyModal" >
                            <div>
                                <span>deseja excluir este endereço?</span>
                            </div>

                            <div className="bodyModalContent">

                                <span>{data.district},{data.street},{data.number}</span>

                                {data.complement &&
                                    <span>{data.complement}</span>
                                }
                                <span>{data.city},{data.state},{cepToMask(data.zipCode)}</span>
                            </div>


                        </div>


                        <div className="footerModal" >

                            <button onClick={() => deleteAddress(data.id)}><span>Excluir endereço</span></button>
                        </div>
                    </div>
                </div>
            )


            }


        </>


    )
}

export { AddressCard }